var React = require('react');

function IconLanguageSymbols (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m20 16h-1.44c-.14 0-.28-.03-.4-.12-.1-.08-.18-.19-.23-.31l-.93-2.57h-5l-1 2.54c-.05.12-.12.22-.22.3-.11.09-.25.14-.4.14h-1.38l4.55-11.47001h1.89zm-3.53-4.31-1.58-4.19001c-.15-.41-.28-.82-.39-1.24-.06.25-.12.48-.19.69l-.19.56-1.58 4.19001h3.93zm-6.3-1.59c-1.02-.35001-2-.82001-2.91-1.41001 1.4-1.51 2.37-3.36 2.81-5.37h1.93v-1.33h-4.69c-.05-.19-.12-.38-.2-.56-.24-.65-.51-1.4399998-.51-1.4399998l-1.47.4999998s.4.89.6 1.5h-5.73v1.33h2.15c.44 2.02 1.42 3.88 2.85 5.37-1.55.96-3.23 1.67001-5 2.10001.37.55.66 1.01.87 1.38 1.84-.62 3.59-1.46 5.22-2.51001 1.11.74001 2.3 1.33001 3.56 1.77001zm-6.54-6.77001h4.91c-.32 1.71-1.18 3.27-2.45 4.45-1.23-1.22-2.08-2.76-2.46-4.45z","fill":"#282828"}));
}

IconLanguageSymbols.defaultProps = {"fill":"none","height":"14","viewBox":"0 0 20 16","width":"18"};

module.exports = IconLanguageSymbols;

IconLanguageSymbols.default = IconLanguageSymbols;
